import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import validtionAddTicket from "../../../validtions/forms/ticket/add-ticket";
import helperSpinner from "../../../helpers/spinner";
import TitleBar from "../../partials/content/TitleBar";

function AddTicket() {
  const [tagFileAttachment, setTagFileAttachment] = useState([]);
  const [categoriesTicket, setCategoriesTicket] = useState();
  const [message, setMessage] = useState();
  const history = useHistory();

  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getCategoriesTicket();
  }, []);

  const getCategoriesTicket = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    generateTagsOptionCategoriesTicket(await sendRequestGetCategoriesTicket());
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const generateTagsOptionCategoriesTicket = (categoriesTicket) => {
    let tagsOptionCategoriesTicket = "";
    tagsOptionCategoriesTicket = categoriesTicket.map(
      (categoryTicket, item) => {
        return (
          <option key={item} value={categoryTicket.id}>
            {categoryTicket.title}
          </option>
        );
      }
    );

    setCategoriesTicket(tagsOptionCategoriesTicket);
  };

  const sendRequestGetCategoriesTicket = async () => {
    const headersRequest = getHeaderForRequset();
    let categoriesTicket;
    try {
      categoriesTicket = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/ticket/categories-ticket",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoriesTicket.data.data;
  };

  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const AddTicketAttachment = () => {
    const tagsExampleTicketAttachment = (
      <div className="py-2">
        <input
          type="file"
          name="file"
          accept=".png, .jpeg,.jpg,.txt, .pdf,.doc, .docx"
          className="form-control"
        />
      </div>
    );

    setTagFileAttachment([...tagFileAttachment, tagsExampleTicketAttachment]);
  };

  const sendForm = async (event) => {
    event.preventDefault();

    const data = getDataForm();

    if (!data) {
      const elmnt = document.getElementById("add-ticket");
      elmnt.scrollIntoView();
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequestPostTicket(data)) {
      history.push("/ticket/all-ticket-user");
      return;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestPostTicket = async (data) => {
    const headersRequest = getHeaderForRequset();

    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/ticket",
        data,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return;
    }

    return true;
  };

  const getDataForm = () => {
    let data = getFilesInput();

    const title = document.getElementById("title").value;
    let text = document.getElementById("text").value;
    const category = document.getElementById("category").value;

    const dataInputs = {
      title: title,
      text: text,
      categoryID: category,
    };
    if (validtionAddTicket(dataInputs) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validtionAddTicket(dataInputs),
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    data.append("title", title);
    data.append("category", category);
    data.append("text", text);

    return data;
  };

  const getFilesInput = () => {
    const countFilesInpit = tagFileAttachment.length;
    const filesInput = document.getElementsByName("file");

    let data = new FormData();

    let j = 1;
    for (let i = 0; i < countFilesInpit + 1; i++) {
      if (filesInput[i].files[0]) {
        data.append("file-" + j, filesInput[i].files[0]);
        j++;
      }
    }
    return data;
  };

  return (
    <>
      <Sidebar openItem="tickets" activeItem="add-tickets" />

      <div className="content-wrapper">
        <TitleBar title="درخواست پشتیبانی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="add-ticket">
              {messageTag}
              <form
                encType="multipart/form-data"
                id="form-tickets"
                onSubmit={sendForm}
              >
                <div className="form-group">
                  <label>عنوان</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                  />
                </div>

                <div className="form-group col-12 col-sm-8 col-md-4">
                  <label>دسته بندی</label>
                  <select id="category" className="form-control">
                    {categoriesTicket}
                  </select>
                </div>

                <div className="form-group">
                  <label>متن</label>
                  <textarea
                    className="form-control"
                    name="text"
                    id="text"
                    rows="12"
                  ></textarea>
                </div>

                <div className="row form-group">
                  <div className="col-sm-12">
                    <label>ضمیمه ها</label>
                  </div>

                  <div className="col-sm-3 col-sm-push-9">
                    <span
                      className="btn btn-default btn-block"
                      onClick={AddTicketAttachment}
                    >
                      <i className="fa fa-plus"></i> افزودن موارد دیگر
                    </span>
                  </div>

                  <div className="col-sm-9 col-sm-pull-3">
                    <div className="pb-2">
                      <input
                        type="file"
                        name="file"
                        accept=".png, .jpeg,.jpg,.txt, .pdf,.doc, .docx"
                        className="form-control"
                      />
                    </div>
                    <div id="fileUploadsContainer">{tagFileAttachment}</div>
                  </div>

                  <div className="col-xs-12 ticket-attachments-message text-muted">
                    پسوند های مجاز: .jpg, .jpeg, .png, .txt, .doc
                  </div>
                </div>

                <button type="submit" className="btn btn-success">
                  ارسال
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AddTicket;
